import { Controller } from '@hotwired/stimulus'
import {
  trans,
  DOWNLOAD,
  ZIP,
  GENERATING_PDF,
  GENERATING_ZIP,
  TRY_AGAIN_LATER
} from '../../translator'
import fetchWithHandlingLoginRedirect from '../../modules/utils/fetchWithHandlingLoginRedirect'
import { v4 as uuidv4 } from 'uuid'

export default class extends Controller {
  static values = {
    reportId: String,
    isZip: { type: Boolean, default: false },
    styleOverride: { type: Boolean, default: false }
  }

  static targets = [
    'text', 'icon', 'spinner', 'iframe'
  ]

  clientDownloadRequestId = null

  connect () {
    const requestIdKey = this.isZipValue ? 'clientPrintRequestId-zip' : 'clientPrintRequestId'
    this.clientDownloadRequestId = sessionStorage.getItem(requestIdKey)
    if (!this.clientDownloadRequestId) {
      this.clientDownloadRequestId = uuidv4()
      sessionStorage.setItem(requestIdKey, this.clientDownloadRequestId)
    }

    document.addEventListener('MercureEvent', this.downloadEventHandler)
  }

  disconnect () {
    document.removeEventListener('MercureEvent', this.downloadEventHandler)
  }

  downloadEventHandler = async (event) => {
    const data = event.detail.data

    if (data.clientRequestId && data.clientRequestId === this.clientDownloadRequestId) {
      if (data.event === 'fileGeneratedEvent' && data.downloadUrl) {
        this.iframeTarget.setAttribute('src', data.downloadUrl)
        this.complete()
      } else if (data.event === 'fileGenerationErrorEvent') {
        this.error()
      }
    }
  }

  processing () {
    this.element.disabled = true
    this.textTarget.innerText = this.isZipValue ? trans(GENERATING_ZIP, {}, 'reports') : trans(GENERATING_PDF, {}, 'reports')
    this.iconTarget.classList.add('d-none')
    this.spinnerTarget.classList.remove('d-none')
  }

  complete () {
    this.element.disabled = false
    this.textTarget.innerText = this.isZipValue ? trans(ZIP, {}, 'reports') : trans(DOWNLOAD, {}, 'actions')
    this.iconTarget.classList.remove('d-none')
    this.spinnerTarget.classList.add('d-none')
  }

  error () {
    this.element.disabled = true
    this.textTarget.innerText = trans(TRY_AGAIN_LATER, {}, 'records')
    this.spinnerTarget.classList.add('d-none')
    this.iconTarget.classList.add('d-none')
    setTimeout(() => {
      this.complete()
    }, 10000)
  }

  download () {
    this.processing()

    const params = new URLSearchParams({
      clientRequestId: this.clientDownloadRequestId
    })

    if (this.isZipValue) {
      params.append('isZip', 'true')
    }

    if (this.styleOverrideValue) {
      params.append('styleOverride', 'true')
    }

    const url = `/report/print/${this.reportIdValue}?${params.toString()}`

    fetchWithHandlingLoginRedirect(url)
      .then((response) => {
        if (response.status === 403) {
          window.location.reload()
        } else if (!response.ok) {
          throw new Error()
        }
      })
      .catch(() => {
        this.error()
      })
  }
}
